import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private api: string = environment.api;
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<User> {
        return this._httpClient.get<User>('api/common/user').pipe(
            tap((user) => {
                this._user.next(user);
            })
        );
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
            })
        );
    }
    getUser(id: string): Observable<any> {
        return this._httpClient.get(`${this.api}/user/getUser/${id}`);
    }
    getAllUsers(userData?: any): Observable<any> {
        const params = new HttpParams({ fromObject: userData }).toString();
        return this._httpClient.get(`${this.api}/user?${params}`);
    }
    deleteUser(user: any): Observable<any> {
        return this._httpClient.post(`${this.api}/user/delete`, user);
    }
    createUser(user: User): Observable<any> {
        return this._httpClient.post(`${this.api}/user/create`, user);
    }
    updateUser(user: any): Observable<any> {
        return this._httpClient.post(`${this.api}/user/update`, {
            username: user.username,
            password: user.password,
        });
    }
    serializeUserData(user: any): any {
        return {
            username: user.username,
            user: user.username,
            roleName: user.roles.name,
            roles: user.roles.name,
            password: user.password,
            description: user.description,
            merchantSlug: user.merchantSlug,
        };
    }
}
